import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {connect} from 'react-redux';
import {setCountrySettings} from '../../../actions/pageSettingsActions';
import CzFlag from './cz-flag.svg';
import SkFlag from './sk-flag.svg';

class CountrySwitcher extends Component {
    handleSelect = event => {
        this.props.setCountrySettings(event.value);
    };

    render() {
        const options = [
            {
                value: 'CZ',
                label: this.props.hasIcon ? (
                    <span className="country-switcher-label">
                        <img src={CzFlag} width={15} height={10} alt="" />
                        <span className="country-name"> Česko</span>
                    </span>
                ) : (
                    'Česká republika'
                )
            },
            {
                value: 'SK',
                label: this.props.hasIcon ? (
                    <span className="country-switcher-label">
                        <img src={SkFlag} alt="" width={15} height={10}/> <span className="country-name"> Slovensko</span>
                    </span>
                ) : (
                    'Slovensko'
                )
            }
        ];

        return (
            <div className={`country-switcher ${this.props.hasIcon ? 'has-icon' : ''}`}>
                <Select
                    name="country-select"
                    classNamePrefix="select"
                    options={options}
                    value={options.filter(({ value }) => value === this.props.country)}
                    onChange={this.handleSelect}
                    searchable={false}
                    clearable={false}
                />
            </div>
        );
    }
}

CountrySwitcher.propTypes = {
    hasIcon: PropTypes.bool
};

function mapStateToProps(state) {
    return {
        country: state.pageSettings.country
    };
}

export default connect(
    mapStateToProps,
    { setCountrySettings }
)(CountrySwitcher);
